import { FavouritesState } from './types'

export const initialState: FavouritesState = {
  items: [],
  hiddenItems: [],
  storeSearchResults: [],
  addToBagVerificationItem: {},

  showAddToBagVerification: false,

  addToBagVerificationError: {
    showError: false,
    errorMessage: '',
  },

  isFavouritesLoading: false,
  isFavouritesPopulated: false,
  isFavouritesLoadingFailed: false,

  isHiddenFavouritesLoading: false,
  isHiddenFavouritesLoaded: false,
  isHiddenFavouritesLoadingFailed: false,

  isFavouritesLoaded: false,

  isStoreSearchResultsLoading: false,
  isStoreSearchResultsPopulated: false,
  isStoreSearchResultsLoadingFailed: false,

  favouritesError: {
    errorGroup: '',
    showError: false,
    displayMode: {
      isModal: false,
      isNotificationBar: true,
    },
  },

  itemSizeGuideResult: '',
}
